import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1939900849989392';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    requestIdleCallback?: (cb: () => void, opts?: {
      timeout: number;
    }) => number;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    // Defer pixel load until the browser is idle (or 3s max) so it doesn't compete
    // with critical hero rendering on mobile — major TBT/FCP/LCP win.
    const load = () => {
      if (window.fbq) return;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(load, {
        timeout: 3000
      });
    } else {
      setTimeout(load, 2000);
    }
  }, []);
  return <noscript data-id="element-21">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-22" />
    </noscript>;
}